<template>
  <div style="width:100%;">
    <h3>{{param.name}}</h3>

    <table
      class="mt-2 v-table"
      style="table-layout:fixed; width:100%;border-spacing:0;"
      :class="{'table-min-width-timeline': $vuetify.breakpoint.mdAndUp}">
      <tr
        v-for="(row, rowIndex) in param.rows"
        :key="rowIndex"
        :class="{'d-block': $vuetify.breakpoint.smAndDown}">
        <td
          v-for="(header, headerIndex) in param.headers"
          :key="headerIndex"
          :class="{'d-block': $vuetify.breakpoint.smAndDown}">
          <v-text-field
            box
            :label="capitalizeRemoveUnderscores(header)"
            :class="{
              'updated-field mr-0': $vuetify.breakpoint.smAndDown && hasRowValueChanged(rowIndex, headerIndex),
              'updated-field mr-2': $vuetify.breakpoint.mdAndUp && hasRowValueChanged(rowIndex, headerIndex),
              'mr-0': $vuetify.breakpoint.smAndDown && !hasRowValueChanged(rowIndex, headerIndex),
              'mr-2': $vuetify.breakpoint.mdAndUp && !hasRowValueChanged(rowIndex, headerIndex)
            }"
            :value="getRowValue(rowIndex, headerIndex)"
            disabled>
            <v-icon
              v-if="hasRowValueChanged(rowIndex, headerIndex)"
              slot="append"
              color="secondary"
            >check_circle</v-icon>
          </v-text-field>
        </td>
        <v-divider class="mb-4 hidden-md-and-up"></v-divider>
      </tr>
    </table>
  </div>
</template>

<script>
import Helpers from "@/helpers"

export default {
  name: "MultipleChanges",
  props: ["param", "caseTypeId"],
  methods: {
    getRowValue(rowIndex, headerIndex) {
      let result = this.param.rows[rowIndex].to[headerIndex]
      if (typeof result === "object") {
        if (result && result.contentType) { // Document
          result = result.filename
        }
        if (result && result.route) { // Address or Location
          result = result.name
        }
        if (result && result.properties) { // Relation
          result = result.properties.title ? result.properties.title : Object.values(result.properties).map((val) => val ? `${val}, ` : "").join("")
        }
      }
      return result
    },
    hasRowValueChanged: function(rowIndex, headerIndex) {
      const toValue = this.param.rows[rowIndex].to[headerIndex]
      const fromValue =
        this.param.rows[rowIndex].from.indexOf(headerIndex) &&
        this.param.rows[rowIndex].from.length
          ? this.param.rows[rowIndex].from[headerIndex]
          : ""
      return !(toValue === fromValue)
    },
    capitalizeRemoveUnderscores: function(val) {
      return Helpers.capitalizeRemoveUnderscores(val)
    }
  }
}
</script>

<style>
  .table-min-width-timeline {
    min-width: 440px;
  }
</style>
